import useMapEvent from 'js/components/DataLayer/hooks/useMapEvent';

function useOnZoomChanged(map, handler) {
  return useMapEvent(map, 'zoom_changed', handler);
}

export default useOnZoomChanged;
